import { createApi } from '@reduxjs/toolkit/query/react';
import { GraphQLClient } from 'graphql-request';
import {
  Login2Document,
  Login2Mutation,
  Login2MutationVariables,
  LoginDocument,
  LoginMutation,
  LoginMutationVariables,
} from './gqlQuery';
import { graphqlRequestBaseQuery } from './graphqlRequestBaseQuery';

/**
 * Create graphql client for redux-toolkit. There will be an associated listener
 * that updates the client Authorization headers when needed.
 * @todo rtkGqlClient.setHeader('authorization', '[new-auth-key');
 */
export const rtkGqlClient = new GraphQLClient(
  `https://gql-${process.env.VITE_APP_COLOR}.${process.env.VITE_APP_KIXIE_DOMAIN}/graphql` as string
);

/**
 * Define a graphql service using a base URL
 * @see https://www.graphql-code-generator.com/docs/plugins/typescript-rtk-query
 * @see https://github.com/reduxjs/redux-toolkit/issues/1361
 * @see https://github.com/reduxjs/redux-toolkit/blob/master/packages/rtk-query-graphql-request-base-query/src/index.ts
 */
export const api = createApi({
  reducerPath: 'gqlQuery',
  baseQuery: graphqlRequestBaseQuery({
    client: rtkGqlClient,
  }),
  // baseQuery: baseQueryWithDisabled,
  endpoints: (build) => ({
    /**
     * Custom Login will send a special x-no-api-key header signalling
     * to cloudfront add the x-api-key header automatically
     */
    CustomLogin: build.mutation<LoginMutation, LoginMutationVariables>({
      query: (variables) => ({
        document: LoginDocument,
        variables,
        requestHeaders: {
          'x-no-api-key': 'REPLACED_BY_CLOUDFRONT_FUNCTION',
        },
      }),
    }),
    /**
     * Custom Login will send a bypass authentication since it is not needed for login
     * However authorization needs to be be pass to trigger lambda auth
     */
    CustomLogin2: build.mutation<Login2Mutation, Login2MutationVariables>({
      query: (variables) => ({
        document: Login2Document,
        variables,
        requestHeaders: {
          authorization: 'FORCE_LAMBDA_AUTH',
        },
      }),
    }),
  }),
});

export type IGqlBase = typeof api;

export const { useCustomLoginMutation, useCustomLogin2Mutation } = api;
